// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import folderApi from '~/apis/folder';
import { CREATE_FOLDER, GET_FOLDER_LIST, UPDATE_FOLDER, DELETE_FOLDER } from '~/utils/constants/actionType';
import { IEditFolder, IFolderParams, IFormFolder } from '~/utils/interface/folder';

export const getFolderList = createAsyncThunk(
  GET_FOLDER_LIST,
  async (params: IFolderParams, { rejectWithValue }) => {
    try {
      const resp = await folderApi.getFolderList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createFolder = createAsyncThunk(
  CREATE_FOLDER,
  async (body: IFormFolder, { rejectWithValue }) => {
    try {
      const resp = await folderApi.createFolder(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editFolder = createAsyncThunk(UPDATE_FOLDER, async (body: IEditFolder, { rejectWithValue }) => {
  try {
    const resp = await folderApi.editFolder(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteFolder = createAsyncThunk(DELETE_FOLDER, async (folderId: string, { rejectWithValue }) => {
  try {
    const resp = await folderApi.deleteFolder(folderId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
